<div class="wrapper">{{ translation.newBadge | translate }}</div>
